module.exports = __webpack_public_path__ + "img/figure-10.0152ceb6.png";